export const FUNIL_COMPONENT_DESIGN = {
    page: {
        container: "flex flex-col h-full w-full gap-6 p-2 md:p-0 animate-in fade-in slide-in-from-bottom-4 duration-500",
        header: {
            container: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4",
            title: "text-2xl font-bold text-gray-900 tracking-tight",
            subtitle: "text-sm text-gray-500 mt-1"
        },
        actionButton: "flex items-center gap-2 px-4 py-2.5 bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-sm font-medium rounded-xl transition-all shadow-sm shadow-[#7C3AED]/20 active:transform active:scale-95"
    },
    tabs: {
        list: "bg-gray-100 p-1 rounded-xl mb-6 w-full md:w-auto inline-flex",
        trigger: "data-[state=active]:bg-white data-[state=active]:text-[#7C3AED] data-[state=active]:shadow-sm text-gray-500 rounded-lg px-4 py-2 text-sm font-medium transition-all"
    },
    emptyState: {
        container: "flex flex-col items-center justify-center p-12 bg-white rounded-xl border border-gray-100 border-dashed text-center",
        iconBox: "w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mb-4 text-gray-400",
        title: "text-lg font-semibold text-gray-900 mb-1",
        description: "text-gray-500 max-w-sm mb-6",
        button: "text-[#7C3AED] font-medium hover:underline text-sm"
    }
};
